<template>
  <div v-if="accordion" class="accordion">
    <AccordionItem :id="`collapse-${title.replace(/\s+/g, '')}`" :parent-id="accordionParent">
      <template #header>
        <span>{{ title }}</span>
        <Badge v-if="showCapacity" :text="`${inhabitants.length} / ${capacity}`" class="ms-2" />
        <Badge v-if="showCount" :text="inhabitants.length" class="ms-2" />
      </template>
      <div class="list-group list-group-flush">
        <span v-for="(person, index) in inhabitants"
              :key="person.reference || person.bookingRef || index"
              @click="linkToPassenger(person)"
              class="list-group-item list-group-item-action d-flex align-items-center justify-content-between">
          <span v-if="person.passengerName">{{ person.passengerName }}</span>
          <span v-else-if="person.name">{{ person.name }}</span>

          <Badge
            v-if="showBrand && person.reference"
            :text="person.reference.split('-')[0]"
            :variant="person.reference.split('-')[0] === 'NUCO' ? 'red-lt' : 'blue-lt'"
            class="ms-auto"
          />
        </span>
      </div>
      <div v-if="inhabitants.length === 0" class="text-muted">
        {{ __DICT__.noInhabitants }}
      </div>
    </AccordionItem>
  </div>

  <!-- Card display (default) -->
  <Card v-else :title="title" show-status-bar margin="mb-4">
    <template #actions>
      <Badge v-if="showCapacity" :text="`${inhabitants.length} / ${capacity}`" />
      <Badge v-if="showCount" :text="inhabitants.length" />
    </template>
    <div class="list-group list-group-flush">
      <span v-for="(person, index) in inhabitants"
            :key="person.reference || person.bookingRef || index"
            @click="linkToPassenger(person)"
            class="list-group-item list-group-item-action d-flex align-items-center justify-content-between">
        <Badge v-if="person.equipment && showEquipment" text="E" pill />
        <Badge v-if="person.dietaryPreferences && !person.dietaryPreferences.startsWith('No Dietary') && person.dietaryPreferences !== '' && showDietary" text="D" pill />
        <span v-if="person.passengerName">{{ person.passengerName }}</span>
        <span v-else-if="person.name">{{ person.name }}</span>

        <Badge
          v-if="showBrand && person.reference"
          :text="person.reference.split('-')[0]"
          :variant="person.reference.split('-')[0] === 'NUCO' ? 'red-lt' : 'blue-lt'"
          class="ms-auto"
        />
      </span>
    </div>
    <div v-if="inhabitants.length === 0" class="text-muted">
      {{ __DICT__.noInhabitants }}
    </div>
  </Card>
</template>

<script setup>
import {useRouter} from "vue-router";
import { AccordionItem, Card, Badge } from "@/components/atomic";

defineProps({
  title: {
    type: String,
    required: true
  },
  inhabitants: {
    type: Array,
    required: true,
    default: () => []
  },
  capacity: {
    type: Number,
    default: null
  },
  showCapacity: {
    type: Boolean,
    default: false
  },
  showEquipment: {
    type: Boolean,
    default: false
  },
  showDietary: {
    type: Boolean,
    default: false
  },
  showCount: {
    type: Boolean,
    default: false
  },
  showBrand: {
    type: Boolean,
    default: false
  },
  accordion: {
    type: Boolean,
    default: false
  }
})

const router = useRouter()

const linkToPassenger = (person) => {
  if (!person) return
  console.log(person)
  if (person.reference) {
    router.push(`/passenger/${person.reference}`)
  } else if (person.bookingRef) {
    router.push(`/passenger/${person.bookingRef}`)
  }
}

</script>
